import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  url?: string;
  type?: string;
  structuredData?: object;
  noindex?: boolean;
}

const SEO: React.FC<SEOProps> = ({
  title = 'Junisama | Alquiler de Baños Portátiles para Eventos en Colombia | Servicio 24/7',
  description = 'Alquiler de baños portátiles premium en Colombia. Unidades VIP, estándar, eléctricos y para discapacitados. Servicio profesional 24/7 con operarios certificados. Cobertura en Bogotá, Medellín y toda Colombia. ☎ +57 350 708 9584',
  keywords = 'baños portátiles Colombia, alquiler baños portátiles, unidades sanitarias portátiles, baños portátiles eventos, baños VIP, lavamanos portátiles, baños Bogotá, baños Medellín, sanitarios eventos, trailer lujo, operarios baños portátiles, puntos ecológicos, Junisama',
  image = 'https://junisama.com.co/images/logo.png',
  url = 'https://junisama.com.co',
  type = 'website',
  structuredData,
  noindex = false,
}) => {
  const siteUrl = 'https://junisama.com.co';
  const fullUrl = url.startsWith('http') ? url : `${siteUrl}${url}`;
  const fullImage = image.startsWith('http') ? image : `${siteUrl}${image}`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={fullUrl} />
      
      {/* Robots */}
      {noindex && <meta name="robots" content="noindex,nofollow" />}
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:locale" content="es_CO" />
      <meta property="og:site_name" content="Junisama Inversiones S.A.S" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={fullUrl} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={fullImage} />

      {/* Additional SEO tags */}
      <meta name="language" content="es-CO" />
      <meta httpEquiv="content-language" content="es-CO" />
      <meta name="author" content="Junisama Inversiones S.A.S" />
      <meta name="geo.region" content="CO" />
      <meta name="geo.placename" content="Colombia" />
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      
      {/* Structured Data / Schema.org */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;

